import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreatePhysiotherapyMutation as useChCreatePhysiotherapyMutationType } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChCreatePhysiotherapyMutation.graphql"

const mutation = graphql`
  mutation useChCreatePhysiotherapyMutation($input: Ch_createPhysiotherapyPrescriptionInput!) {
    ch_createPhysiotherapyPrescription(input: $input) {
      ch_PhysiotherapyPrescription {
        id
        healthcareProviderId
        ...chPhysiotherapyFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreatePhysiotherapyMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreatePhysiotherapyMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreatePhysiotherapyMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreatePhysiotherapyMutation }
